import { Button, Chip } from '@material-ui/core';
import { CheckCircleRounded, RadioButtonUncheckedOutlined } from '@material-ui/icons';
import { getStudentAffiliate } from '@webapps/business';
import { Modal, useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Tooltip from 'components/Tooltip';
import { useState } from 'react';
import Contract from './Contract';


const AffiliateInfo = ({ id, refetch }) => {
  const {
    css,
    classes,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);
  const { data: { data: info = [] } = {}, refetch: refetchInfoContract } =
    useQuery(getStudentAffiliate, {
      key: ['infoStudentSchoolAffiliatee', id],
      variables: { id, type: 'school', status: 'enclosed' },
    });

  const [viewSendContract, setViewSendcontract] = useState(false);

  const handleOpenViewSendContract = () => {
    setViewSendcontract(true);
  };
  const handleCloseViewSendContract = () => {
    setViewSendcontract(false);
  };

  return (
    <>
      {!info[0]?.contract ? (
        <div style={{ width: '100%' }}>
          {info[0]?.contract === null && <Button
            className={css({ padding: spacing(1), width: '100%', backgroundColor: 'white' })}
            color="primary"
            onClick={() => handleOpenViewSendContract()}
            variant="outlined"
          >
            Envoyer le contrat tripartite
          </Button>
          }
        </div>
      ) : (
        <div>
          {info[0]?.contract.schoolSignAction !== null && info[0]?.contract.studentSignAction !== null && info[0]?.contract.businessSignAction !== null ? (
            <Chip
              classes={{
                colorPrimary: css({
                  background: '#dbfad8',
                  color: 'green',
                  lineHeight: '32px'
                }),
              }}
              className={classes.chip}
              color="primary"
              label="Contrat signé (en cours)"
            />
          ) : (
            <div>
              {
                info[0]?.contract.schoolSignAction === null && info[0]?.contract.studentSignAction === 'SIGNED' && info[0]?.contract.businessSignAction === null ||
                  info[0]?.contract.schoolSignAction === 'SIGNED' && info[0]?.contract.studentSignAction === null && info[0]?.contract.businessSignAction === null ||
                  info[0]?.contract.schoolSignAction === null && info[0]?.contract.studentSignAction === null && info[0]?.contract.businessSignAction === 'SIGNED' ? (
                  <Chip
                    classes={{
                      colorPrimary: css({
                        background: '#FAE8D7',
                        color: '#FA8100',
                        lineHeight: '32px'
                      }),
                    }}
                    className={classes.chip}
                    color="primary"
                    label="Contrat signé 1/3"
                  />) : (info[0]?.contract.schoolSignAction === null && info[0]?.contract.studentSignAction === 'SIGNED' && info[0]?.contract.businessSignAction === 'SIGNED' ||
                    info[0]?.contract.schoolSignAction === 'SIGNED' && info[0]?.contract.studentSignAction === 'SIGNED' && info[0]?.contract.businessSignAction === null ||
                    info[0]?.contract.schoolSignAction === 'SIGNED' && info[0]?.contract.studentSignAction === null && info[0]?.contract.businessSignAction === 'SIGNED' ? (
                    <Chip
                      classes={{
                        colorPrimary: css({
                          background: '#FAE8D7',
                          color: '#FA8100',
                          lineHeight: '32px'
                        }),
                      }}
                      className={classes.chip}
                      color="primary"
                      label="Contrat signé 2/3"
                    />) : (info[0]?.contract.schoolSignAction === null && info[0]?.contract.schoolSignAction === null && info[0]?.contract.schoolSignAction === null &&
                      <Chip
                        classes={{
                          colorPrimary: css({
                            background: '#FAE8D7',
                            color: '#FA8100',
                            lineHeight: '32px'
                          }),
                        }}
                        className={classes.chip}
                        color="primary"
                        label="Contrat signé 0/3"
                      />))}
            </div>
          )}
        </div>
      )}
      <Modal
        onCancel={handleCloseViewSendContract}
        open={viewSendContract}
        subTitle="Et signez le automatiquement"
        title="Envoyez un contrat"
        withStep={false}
      >
        <Contract
          close={handleCloseViewSendContract}
          refetch={refetch}
          refetchInfoContract={refetchInfoContract}
          selectedStudent={info[0]}
        />
      </Modal>
    </>
  );
};

const styles = ({ spacing }) => ({
  formations: {
    marginTop: spacing(2),
  },
  infoCandidat: { display: 'flex', alignItems: 'center', width: '100%' },
  tableHead: {
    '&.MuiTableCell-head': {
      color: 'white',
    },
  },
  chip: {
    padding: spacing(2.5),
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 'regular',
    '@media only screen and (max-width:768px)': { fontSize: 12, padding: 0, maring: 0 },




  },
  chipContainer: {
    marginBottom: spacing(0),
  },
});

export default AffiliateInfo